"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Portal;
var _reactDom = require("react-dom");
var _usePortal = _interopRequireDefault(require("../../hooks/usePortal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Portal(_ref) {
  var id = _ref.id,
    children = _ref.children;
  var target = (0, _usePortal["default"])(id);
  if (typeof window !== 'undefined' && target) {
    return /*#__PURE__*/(0, _reactDom.createPortal)(children, target);
  }
  return null;
}
module.exports = exports.default;